<template>
	<router-link class="header" to="/" tag="header">
		<h1>Vibesniper</h1>
	</router-link>
</template>

<script>
export default {
	name: 'Header',
};
</script>

<style lang="scss" scoped>
.header {
	background: $primary;
	color: white;
	cursor: pointer;
	height: 60px;
	left: 50%;
	letter-spacing: 0.2em;
	padding: 1em 1em 1em 1.2em;
	position: fixed;
	text-align: center;
	text-transform: uppercase;
	top: 0;
	transform: translateX(-50%);
	user-select: none;
	width: 500px;
	z-index: 100;

	h1 {
		font-weight: 400;
		margin: 0;
		padding: 0;
	}
}
</style>
